import { TAG_TYPES } from '@app/api/tagTypes';
import { DOCUMENTS_ENDPOINTS } from '@app/configs/api/documents';
import { openPdfInNewWindow } from '@app/utils/pdfHandler';
import { baseApi } from './baseApi';
export const documentsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDocumentPdf: builder.mutation({
            query: ({ resourceId, documentType }) => ({
                url: DOCUMENTS_ENDPOINTS.pdf,
                params: {
                    resourceId,
                    documentType,
                },
                responseType: 'arraybuffer',
            }),
            transformResponse: (response) => {
                openPdfInNewWindow(response);
                return undefined;
            },
            invalidatesTags: [TAG_TYPES.DOCUMENTS],
        }),
    }),
    overrideExisting: false,
});
export const { useGetDocumentPdfMutation } = documentsApi;
